import { ModuleRegistry, ServerSideRowModelModule } from 'ag-grid-enterprise';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import { ServerGridConfig } from '../../../../config/GridConfig';
import { faEye, faLink, faPencil, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	const { openEditModal, openDeleteModal } = props;
	const { ACCOMMODATION, MERCHANT, AUTH } = useStore();
	const { user } = AUTH;
	const ActionRenderer = (props) => {
		return (
			<div className="action-column">
				{/* <Button type="text" title={'View'} className="viewIcon">
					<FontAwesomeIcon icon={faEye} />
				</Button> */}
				<Button
					type="text"
					title={'Edit'}
					className="editIcon"
					onClick={() => {
						ACCOMMODATION.ReadMerchant(props.data.id);
						openEditModal();
					}}
				>
					<FontAwesomeIcon color="#1723ad" icon={faPencil} />
				</Button>
				<Button
					type="text"
					title={'Delete'}
					className="deleteIcon"
					onClick={() => {
						openDeleteModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faTrashAlt} color={'red'} />
				</Button>
				{(user && user.id) === process.env.REACT_APP_SUPER_ADMIN_ID && (
					<Button
						type="text"
						title={'Proxy login'}
						onClick={() => window.open(`https://${props.data.shortName}.${process.env.REACT_APP_MERCHANT_BASE_URL || ''}?username=${user?.id}`, "_blank")}
					>
						<FontAwesomeIcon icon={faLink} color={'green'} />
						<link to={props.data.url}></link>
					</Button>
				)}
			</div>
		);
	};

	const colDefs = [
		{
			headerName: 'Merchant Name',
			field: 'merchantName',
			sort: 'asc',
			minWidth: 140,
		},
		{
			headerName: 'Short Name',
			field: 'shortName',
			minWidth: 140,
		},
		{
			headerName: 'State Name',
			field: 'stateName',
			minWidth: 140,
			sortable: false,
		},
		{
			headerName: 'City Name',
			field: 'cityName',
			minWidth: 140,
			sortable: false,
		},
		{
			headerName: 'Contact',
			field: 'phoneNo',
			minWidth: 140,
		},
		{
			headerName: 'Active Plan',
			field: 'subscriptionName',
			minWidth: 140,
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 120,
			width: 120,
		},
	];

	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container>
		>
			<AgGridReact
				onGridReady={ACCOMMODATION.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				rowSelection={'multiple'}
				components={{
					ActionRenderer,
					openEditModal,
				}}
			/>
		</div>
	);
});
export default ListComponent;
